export default __webpack_public_path__ + "static/media/6.a1359a63.jpg";